export default "__VITE_ASSET__af344799__"